export default __webpack_public_path__ + "static/media/Photo_Home@2x.82b23c90.jpg";